<template>
  <div id="period">
    <h1>Good Morning, {{ firstname }}!</h1>
    <p>Today we are going to...</p>
    <hr class="uk-divider-icon">
    <ol class="lessons">
        <li>
            <h3>Open Google Hangout</h3>
            <p>Open our class Google Hangout to check in then come back here to complete the next task.</p>
            <a href="https://meet.google.com/lookup/h54m65h2qe?authuser=0&hs=179" target="_blank" class="uk-button uk-button-primary uk-button-medium">Open Google Meet</a>
            <hr class="uk-divider-icon">
        </li>
        <li v-for="work in getAttendanceClasswork" :key="work.id">
          <h3>{{ work.title }}</h3>
          <p>{{ work.description }}</p>
          <a :href="work.materials[0].form.formUrl" target="_blank" class="uk-button uk-button-primary uk-button-medium">View Form</a>
          <hr class="uk-divider-icon">
      </li>
    </ol>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: "AttendanceVue",
  components: {
  },
  created() {
    console.log('call retrieve attendance classwork action');
    this.retrieveAttendanceClassworkAction();
    this.splitNames();
  },
  computed: {
    ...mapGetters(["getUser", "getAttendanceClasswork"])
  },
  data: function() {
    return {
      firstname: '',
      lastname: ''
    }
  },
  methods: {
    ...mapActions(["retrieveAttendanceClassworkAction"]),
    splitNames: function() {
      const displayName = this.getUser.displayName.split(" ");
      this.firstname = displayName[0];
      this.lastname = displayName[1];
    }
  }
};
</script>
